import { queryOptions } from '@tanstack/react-query';

import { STANDARD_STALE_TIME } from '$/services/constants';
import {
  getInvitationById,
  getSchoolInvitationRequests,
  getStudentInvitations,
  getTeacherInvitations,
} from '$/services/usecases/invitation';

export const invitationRequestQuery = (id: string) =>
  queryOptions({
    queryKey: ['invitationRequest', id],
    queryFn: ({ signal }) => getInvitationById(id, signal),
    staleTime: STANDARD_STALE_TIME,
  });

export const studentInvitationsQuery = queryOptions({
  queryKey: ['invitationRequest', 'students'],
  queryFn: ({ signal }) => getStudentInvitations(signal),
  staleTime: STANDARD_STALE_TIME,
});

export const teacherInvitationsQuery = queryOptions({
  queryKey: ['invitationRequest', 'teachers'],
  queryFn: ({ signal }) => getTeacherInvitations(signal),
  staleTime: STANDARD_STALE_TIME,
});

export const schoolRequestsQuery = queryOptions({
  queryKey: ['invitationRequest', 'schools'],
  queryFn: ({ signal }) => getSchoolInvitationRequests(signal),
  staleTime: STANDARD_STALE_TIME,
});
